module.exports = __webpack_public_path__ + "static/media/y-icon.1c8f021b.svg";